import { useTheme } from '@emotion/react';
import { CircularProgress } from '@mui/material';

export default function CircularLoading() {
  const theme = useTheme();
  // 브랜드 primary — 팅글은 핑크(#F95388), 버블챗은 시안(#00E0FF)
  return <CircularProgress sx={{ color: theme.color.static.primary }} />;
}
